import { useLocalStorage } from "@rehooks/local-storage";
import { differenceInDays, fromUnixTime } from "date-fns/esm";
import { useCallback } from "react";
import { useNavigate } from "react-router";

import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";

const LOCAL_STORAGE_KEY = "redirectedToLaunchPad";

export const useLaunchpadRedirect = () => {
  const { viewer } = useTypedContext(AccountContext);
  const [redirectedToLaunchPad, setRedirectedToLaunchPad] =
    useLocalStorage<boolean>(LOCAL_STORAGE_KEY);

  const navigate = useNavigate();

  const shouldRedirectToLaunchpad =
    !redirectedToLaunchPad &&
    viewer.admin &&
    viewer.since &&
    differenceInDays(new Date(), fromUnixTime(viewer.since)) < 1;

  const redirectToLaunchpad = useCallback(() => {
    setRedirectedToLaunchPad(true);
    navigate("/launchpad", { replace: true });
  }, [navigate, setRedirectedToLaunchPad]);

  return {
    shouldRedirectToLaunchpad,
    redirectToLaunchpad,
  };
};
